export default "__VITE_ASSET__C2C$P8fZ__"